import { Link } from 'react-router-dom';

function companyNumber(original) {
  return (
    <Link to={`/companies/edit/${original?.id}`}>
      {original?.companyNumber || ''}
    </Link>
  );
}

function companyType(original) {
  return original?.companyType || '';
}

function companyNumberInternal(original) {
  return original?.companyNumberInternal || '';
}

function status(original) {
  return original?.status ? 'Active' : 'In-Active';
}

export { companyNumber, companyType, companyNumberInternal, status };
